import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaDownload } from "react-icons/fa";

function Header({ userData }) {
  const [tokenPresent, setTokenPresent] = useState(false);
  const [localUserData, setLocalUserData] = useState(userData);
  const navigate = useNavigate();
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/apk/myapp.apk"; // path from public folder
    link.download = "myapp.apk"; // downloaded file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    
    // If userData is not passed as prop, load from localStorage
    if (!userData && user) {
      try {
        setLocalUserData(JSON.parse(user));
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    }
    
    if (!token) {
      navigate("/");
    } else {
      setTokenPresent(true);
    }
  }, [userData]);

  const handleLogout = () => {
    // Clear all localStorage items
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("AdminName");
    localStorage.removeItem("packageEditData");
    
    // Clear sessionStorage as well
    sessionStorage.clear();
    
    // Clear all cookies (if any)
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Force a full page reload to clear all React state
    window.location.href = "/";
  };

  return (
    <div className="app-header app-header-dark">
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary py-lg-0">
        <div className="container-fluid">
          <button
            className="hamburger hamburger-squeeze d-flex d-lg-none"
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
              <li className="nav-item">
                <Link to={"/dashboard"} className="nav-link">
                  Dashboard <span className="sr-only">(current)</span>
                </Link>
              </li>
              {/* allleaves */}
              <li className="nav-item dropdown">
                <Link
                  to={"/allleaves"}
                  className="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  All Leaves
                </Link>
                {/* <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <Link to={"/allleaves"} className="dropdown-item">
                    All Leaves
                  </Link>
                  <Link to={"/getpenalty"} className="dropdown-item">
                    Get Penalty
                  </Link>
                </div> */}
              </li>

              <li className="nav-item">
                <Link to={"/PageAdd"} className="nav-link">
                  Add Page
                </Link>
              </li>

              <li className="nav-item">
                <Link to={"/delete-account"} className="nav-link">
                  Delete Account
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/sp-message"} className="nav-link">
                  Sp Message
                </Link>
              </li>


              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  href="#"
                  id="navbarPagesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <span className="mr-1">Jobs</span>
                  <i className="fas fa-angle-down ml-auto"></i>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarPagesDropdown"
                >
                  <li className="dropright">
                    <Link
                      to="/todaysjob"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Today Jobs</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/upcomingjob"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Upcoming Jobs</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/canceledjob"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Canceled Jobs</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/inquiry"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Enquiries</span>
                    </Link>
                  </li>

                  <div className="dropdown-divider"></div>
                  <li className="dropright">
                    <Link
                      to="/createjob"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <i className="fa fa-plus-circle mb-1 mr-1"></i>
                      <span className="mr-1">Create Job</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  href="#"
                  id="navbarPagesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <span className="mr-1">Item</span>
                  <i className="fas fa-angle-down ml-auto"></i>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarPagesDropdown"
                >
                  <li className="dropright">
                    <Link
                      to="/parentCategoryGroup"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Parent Category Group</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/parentCategory"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Parent Category</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/childCategory"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Child Category</span>
                    </Link>
                  </li>
                  <div className="dropdown-divider"></div>
                  <li className="dropright">
                    <Link
                      to="/servicegroup"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Service Group</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/servicetype"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Service Type</span>
                    </Link>
                  </li>
                  <div className="dropdown-divider"></div>
                  <li className="dropright">
                    <Link
                      to="/service"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Service</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/package"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Package</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  href="#"
                  id="navbarPagesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <span className="mr-1">Master</span>
                  <i className="fas fa-angle-down ml-auto"></i>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarPagesDropdown"
                >

                  <li className="dropright">
                    <Link
                      to="/appversion"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">App Version</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/coupons"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Coupons</span>
                    </Link>
                  </li>

                  <li className="dropright">
                    <Link
                      to="/slot"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Slot </span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/costumers"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Costumers </span>
                    </Link>
                  </li>

                  {/* sp cashback rules */}
                  <li className="dropright">
                    <Link
                      to="/sp-cashback-rules"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">SP Cashback Rules</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/wallet"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Wallet</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/cashback"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Cashback</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/wallet-fund-rules"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Wallet Fund Rules</span>
                    </Link>
                  </li>
                  <li>
                  <Link
                      to="/leadgeneration"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Lead Generation</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  href="#"
                  id="navbarPagesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <span className="mr-1">Appearance</span>
                  <i className="fas fa-angle-down ml-auto"></i>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarPagesDropdown"
                >
                  <li className="dropright">
                    <Link
                      to="/paymentgateway"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Payment Gateway</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/Notification"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Notification</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/placeholderimage"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Placeholder Image</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/Packagediscount"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Package Discount</span>
                    </Link>
                  </li>

                  <li className="dropright">
                    <Link
                      to="/Coverimage"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Cover Image</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/heroSlider"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Hero Slider</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/offers4u"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Offers4U</span>
                    </Link>
                  </li>

                  {/* <li className="dropright">
                    <Link
                      to="/Homebanner"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Home Banner</span>
                    </Link>
                  </li> */}
                  <div className="dropdown-divider"></div>
                  <li className="dropright">
                    <Link
                      to="/parentSlider"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Parent Slider</span>
                    </Link>
                  </li>

                  <li className="dropright">
                    <Link
                      to="/testimonial"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Testimonial</span>
                    </Link>
                  </li>

                  <li className="dropright">
                    <Link
                      to="/branduse"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Brand Used</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/faqQuestion"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Faq Question/Answer</span>
                    </Link>
                  </li>
                  <div className="dropdown-divider"></div>
                  <li className="dropright">
                    <Link
                      to="/otherchages"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Other Charges</span>
                    </Link>
                  </li>
                  <li className="dropright">
                    <Link
                      to="/professional-preference"
                      className="dropdown-item d-flex align-items-center"
                    >
                      <span className="mr-1">Professional Preference</span>
                    </Link>
                  </li>

                  <li className="dropright ">
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="javascript:void(0)"
                      id="sectionDroupdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span className="mr-1">Home Section</span>
                      <i class="fas fa-angle-right ml-auto"></i>
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="sectionDroupdown"
                    >
                      <li>
                        <Link
                          to="/ServiceShortcutHeading"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <span className="mr-1">Section</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/Serviceshortcut"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <span className="mr-1">Shortcut Service</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/videoShortcut"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <span className="mr-1">Video ShortCut</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/Homebanner"
                          className="dropdown-item d-flex align-items-center"
                        >
                          <span className="mr-1">Home Banner</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/serviceProvider">
                  Service Provider
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/add-id-card">
                  Add Id Card
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/penalty">
                  Penalty
                </Link>
              </li>

            </ul>

            <div className="navbar-nav dropdown d-flex mr-lg-n3  align-item-center">
              <button className="btn bg-transparent my-auto" onClick={() => { navigate("/apk-upload") }} >
                <FaDownload color="white" size={20} />

              </button>
              <button
                className="btn-account w-100"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="user-avatar user-avatar-md mr-lg-0">
                  <img src="/assets/images/avatars/profile.jpg" alt="" />
                </span>
                <span className="account-summary pr-lg-4 d-none d-lg-block ml-3">
                  <span className="account-name">
                    {(userData || localUserData) ? (userData?.name || localUserData?.name) : "Guest"}
                  </span>
                  <span className="account-description">Admin</span>
                </span>
              </button>
              <div className="dropdown-menu dropdown-menu-right">
                <div className="dropdown-arrow mr-3"></div>

                <button
                  type="button"
                  onClick={() => {
                    console.log("clicked");
                    handleLogout();
                  }}
                  href="javascript:void(0)"
                  className="dropdown-item"
                >
                  <span className="dropdown-icon oi oi-account-logout"></span>
                  Logout
                </button>

                {/* change password */}
                <button
                  type="button"
                  onClick={() => {
                    navigate("/change-password");
                  }}
                  className="dropdown-item"
                >
                  <span className="dropdown-icon oi oi-account-logout"></span>
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
